module.exports = __webpack_public_path__ + "static/media/meta02.0913c587.jpg";